// removed by extract-text-webpack-plugin
module.exports = {"picker":"_2mxQC56A8C7ao0DCBPMyMY","header":"qlpJpdgMDnhfBIBfdHFGC","close":"_1aJ5Su6KlIIplDs23BzDzW","btn":"_2X6jVHnDWJMcz5TDFeloxI","isDisplayed":"_-5g-F2a9HTgzcfHoyGXBx"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InstagramPicker/InstagramPicker.scss
 ** module id = 733
 ** module chunks = 0
 **/